import { useMemo } from "react";
import _ from "lodash";

export const useFormFieldErrors = (formDefinedErrors, formError = '') => {
    return useMemo(() => {
            const fieldErrors = Object
                .entries(formDefinedErrors)
                .reduce((accum, [field, errors]) => ({
                    ...accum,
                    [field]: errors.includes(formError) ? formError : ''
                }), {});
            const allDefinedErrors = _.flatten(Object.values(formDefinedErrors));
            const common = allDefinedErrors.includes(formError) ? '' : formError;
            return {...fieldErrors, common};
        }, [formDefinedErrors, formError]
    );
}
